<template>
  <eye-exam-card
    class="medical-record-exam-view"
    title="Retinografia"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :rows-definition="table.body"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  />
</template>

<script>
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'RetinographyView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: {
        body: [
          {
            label: 'Escavação',
            R: 'valueR',
            L: 'valueL',
            formatter: v => v || '',
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
